<template>
    <div ref="info" class="page-warpper flex flex-direction">
        <header-modular :url="web_emof_home"></header-modular>
        <div class="container  flex-sub">
            <div class="page-container flex flex-direction flex-sub">
                <div class="content-container flex-sub">
                    <div class="content flex-sub">
                        <div class="flex align-center justify-between">
                            <div class="page-title">版本更新</div>
                            <div class="page-back" @click="$router.go(-1)">返回</div>
                        </div>
                        <empty v-if="lists.length === 0" :type="0"/>
                        <div class="flex flex-direction">
                            <div v-for="(item,index) in lists" :key="index" class="item-notice flex align-center justify-between" @click="showDetail(item.id)">
                                <div class="title">{{ item.title }}</div>
                                <div class="time">{{ item.create_time }}</div>
                            </div>
                        </div>
                        <el-pagination
                            v-if="lists.length>0"
                            :current-page.sync="page"
                            :page-size="limit"
                            :total="total"
                            background
                            class="page-all margin-top"
                            layout="prev, pager, next, jumper"
                            @current-change="init">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <footer-modular></footer-modular>
        <version-detail-dialog :detailDialogVisible="detailDialogVisible" :nid="cur_nid"
                               @watchState="watchState"></version-detail-dialog>
    </div>
</template>

<script>
import HeaderModular from "@/components/HeaderModular.vue";
import FooterModular from "@/components/FooterModular.vue";
import {web_emof_home} from '@/utils/const'
import {getVersionList} from "../api/login";
import {zhDate} from "../utils/utils";
import VersionDetailDialog from "../components/VersionDetailDialog";
import config from '/package.json'

export default {
    name: "Version",
    components: {
        VersionDetailDialog,
        FooterModular, HeaderModular
    },
    data() {
        return {
            web_emof_home: web_emof_home,
            lists: [],
            page: 1,
            limit: 10,
            total: 0,

            cur_nid: 0,
            detailDialogVisible: false,
        }
    },
    created() {
        window.localStorage.setItem('version', config.version)
        this.init()
    },
    computed: {},
    methods: {
        async init() {
            let _data = await getVersionList(this.page, this.limit)

            _data.data.map(item => {
                item.create_time = zhDate(item.create_time * 1000)
            })
            this.lists = _data.data
            this.total = _data.total_number
        },
        showDetail(id) {
            this.cur_nid = id
            this.detailDialogVisible = true;
        },
        watchState() {
            this.detailDialogVisible = false;
        },
    }

}
</script>

<style lang="scss" scoped>
.page-warpper {
    height: 100vh;
    background: #ebeff5;

    .container {
        display: flex;
        flex-direction: column;
        width: 1200px;
        margin: 0 auto;

        .page-container {
            margin: 15px 0;

            .content-container {
                display: flex;
                flex-direction: column;
                background-color: #0a2240;
                border-radius: 10px;
                padding: 15px;
                margin-left: 10px;

                .content {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    background-color: #ffffff;
                    border-radius: 10px;
                    padding: 30px;

                    .item-notice {
                        width: 100%;
                        height: 70px;
                        cursor: pointer;
                        .title {
                            font-size: 20px;
                            font-weight: bold;
                            color: #0a2240;
                        }

                        .time {
                            font-size: 16px;
                            color: #666666;
                        }

                        border-bottom: 1px solid #eeeeee;
                    }

                }
            }
        }

    }
}
</style>